import { CompilerComponent, IconName } from '@types';

import { block } from './block';
import { component } from './component';
import { defaultProps, protocolFactory } from './protocol';

export default {
  block,
  component,
  defaultProps,
  protocolFactory,
} as CompilerComponent<{}>;
